<template>
  <div class="review-content">
    <h3 class="top">评论</h3>
    <div class="content"></div>
    <div class="bottom">
      <Input
        v-model="commentText"
        type="textarea"
        :border="false"
        :autosize="{ minRows: 5, maxRows: 8 }"
        placeholder="输入内容..."
      />
      <div class="bottom-button">
        <Button type="success" ghost>设为任务</Button>
        <Button
          type="primary"
          ghost
          style="margin-left: 5px"
          @click="createCommentMethod"
          >发表评论</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Comment",
  data() {
    return {
      commentText: null,
    };
  },
  methods: {
    ...mapActions({
      createComment: "comment/createCommentAction",
      getComments: "comment/getCommentsAction",
    }),
    async createCommentMethod() {
      if (this.commentText) {
        try {
          await this.createComment({
            comment: this.commentText,
            customer: this.customer._id,
          });
          this.$Message.success("发表成功");
          this.commentText = null;
        } catch (error) {
          this.$Message.error("发表失败" + error);
        }
      }
    },
  },
  mounted() {
    this.getComments({ customer: this.customer._id });
  },
  computed: {
    ...mapState({
      detailCustomersId: (state) => state.customer.detailCustomersId,
      customer: (state) => state.customer.selectCustomer,
    }),
  },
  watch: {
    // 选择的客户改变时，清空textarea内容
    customer() {
      this.commentText = null;
    },
  },
};
</script>
<style lang="stylus" scoped>
.review-content
  height 100%
  border 1px solid #000
  position relative

  .top
    background-color #F5F5F5
    border-bottom 1px solid #000
    padding-left 5px

  .bottom
    width 305px
    position absolute
    bottom 0
    border 1px solid #b9b9b9
    margin 0 0 7px 5px

.bottom-button
  display flex
  justify-content flex-end
  margin 0 2px 2px 0
</style>